onComplete(function () {

	const isHome = document.querySelector("html[data-home='true']");
	const header = document.querySelector('header.nav-header');

	const logo = document.querySelector(".navbar .logo");

	let prevScrollPos;
	let currentScrollPos = document.documentElement.scrollTop;

	let isMobile = window.matchMedia('(max-width: 992px)');

	if (isHome && !isMobile.matches) {
		logo.setAttribute('src', 'static/logov3.svg');
	}

	window.addEventListener('scroll', function () {

		if (isHome) {

			if (!isMobile.matches) {
				logo.setAttribute('src', 'static/logov3.svg');
				currentScrollPos = document.documentElement.scrollTop;
				if (prevScrollPos > currentScrollPos || prevScrollPos <= 0) {
					header.style.translate = "0 0";
				} else {
					header.style.translate = "0 -100%";
				}
				prevScrollPos = currentScrollPos;

				const changeNavbarBg = () => {
					currentScrollPos = document.documentElement.scrollTop;
					if (currentScrollPos > 50) {
						header.style.backgroundColor = "var(--tertiary)";
						logo.setAttribute('src', 'static/logo_white.svg');
					} else {
						header.style.backgroundColor = "transparent";
					}
				}
				changeNavbarBg()
			}
		}

	});

});